module.exports = __webpack_public_path__ + "img/tintuc3.7eaa16bd.png";